import React from 'react';
import { DisplayText, HeadingText } from '@paypalcorp/pp-react';

const NotFound: React.FC = () => {
  const notFoundStyle: React.CSSProperties = {
    minHeight: '75vh',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: '40px 20px',
    textAlign: 'center'
  };

  const textContainer: React.CSSProperties = {
    marginTop: '8%'
  };

  return (
    <div style={notFoundStyle}>
      <div style={textContainer}>
        <DisplayText size="sm">Page not found</DisplayText>
        <br />
        <HeadingText size="sm">We can’t find a page with the url you entered.</HeadingText>
      </div>
    </div>
  );
};

export default NotFound;
